import { createFileRoute } from '@tanstack/react-router'
import { Helmet } from 'react-helmet-async'
import {
  Navbar,
  Hero,
  MarqueeStrip,
  FeaturesSection,
  ComparisonTable,
  Footer,
} from '@/components/landing'
import { EmailsYourWayA } from '@/components/landing/emails-your-way-a'
import { PricingSectionB } from '@/components/landing/pricing-section-b'

function LandingPage() {
  return (
    <div
      style={{
        fontFamily: 'var(--oe-font-sans)',
        background: '#FDF8F3',
        color: '#1a1216',
        minHeight: '100vh',
        overflowClipMargin: 'content-box',
        overflowX: 'clip',
      }}
    >
      <Helmet>
        <title>Email platform for people who hate overpaying | One-Email</title>
        <meta
          name="description"
          content="One-Email is the email platform for developers and teams who want fast delivery, transparent pricing, and no surprises on their bill."
        />
        <link rel="canonical" href="https://one-email.com/" />
      </Helmet>
      <Navbar />
      <main id="main-content">
        <Hero />
        <MarqueeStrip />
        <FeaturesSection />
        <PricingSectionB />
        <EmailsYourWayA />
        <ComparisonTable />
        {/* <CTASection /> */}
        {/* <WhySection /> */}
      </main>
      <Footer />
    </div>
  )
}

export const Route = createFileRoute('/')({
  component: LandingPage,
})
